import { render, staticRenderFns } from "./AppDetails.vue?vue&type=template&id=41975140&scoped=true"
import script from "./AppDetails.vue?vue&type=script&lang=js"
export * from "./AppDetails.vue?vue&type=script&lang=js"
import style0 from "./AppDetails.vue?vue&type=style&index=0&id=41975140&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41975140",
  null
  
)

export default component.exports